import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { spotFinder, userManagement } from '../app/endpoints';
import axiosBaseQuerySpotfinder from './axiosBaseQuerySpotfinder';

export const serviceProviderApi = createApi({
    reducerPath: 'serviceProviderApi',
    baseQuery: axiosBaseQuerySpotfinder({ baseUrl: process.env.REACT_APP_SPOT_FINDER_BASE_URL }),
    tagTypes: ['serviceProvider'],
    endpoints: (builder) => ({
        getAllServiceProviderDetail: builder.mutation({
            query(body) {
                return {
                    url: `${spotFinder.serviceProviderDetailController.getAllServiceProviderDetail}`,
                    method: 'POST',
                    headers: body.token ? { Authorization: `Bearer ${body.token}` }: {},
                    body: body.payload,
                };
            },
        }),
        findServiceProviderDetailById: builder.mutation({
            query(body) {
                return {
                    url: `${spotFinder.serviceProviderDetailController.findServiceProviderDetailById}${body.id}`,
                    method: 'GET',
                    headers: body.token ? { Authorization: `Bearer ${body.token}` }: {},
                };
            },
        }),
        findServiceProviderDetailByUserId: builder.mutation({
            query(body) {
                return {
                    url: `${spotFinder.serviceProviderDetailController.findServiceProviderDetailByUserId}${body.userId}`,
                    method: 'GET',
                    headers: body.token ? { Authorization: `Bearer ${body.token}` }: {},
                };
            },
        }),
        saveServiceProviderDetail: builder.mutation({
            query(body) {
                return {
                    url: `${spotFinder.serviceProviderDetailController.saveServiceProviderDetail}`,
                    method: 'POST',
                    headers: body.token ? { Authorization: `Bearer ${body.token}` }: {},
                    body: body.payload,
                };
            },
        }),
        updateServiceProviderDetail: builder.mutation({
            query(body) {
                return {
                    url: `${spotFinder.serviceProviderDetailController.updateServiceProviderDetail}`,
                    method: 'PUT',
                    headers: body.token ? { Authorization: `Bearer ${body.token}` }: {},
                    body: body.payload,
                };
            },
        }),
        deleteServiceProviderDetail: builder.mutation({
            query(body) {
                return {
                    url: `${spotFinder.serviceProviderDetailController.deleteServiceProviderDetail}${body.id}`,
                    method: 'DELETE',
                    headers: body.token ? { Authorization: `Bearer ${body.token}` }: {},
                };
            },
        }),
        serviceProviderId: builder.mutation({
            query: (body) => {
                return {
                    url: `/serviceProviderDetail/findByUserId/${body.id}`,
                    method: 'GET',
                    headers: body.token ? { Authorization: `Bearer ${body.token}` }: {},
                };
            },
        }),
    }),
});

export const {
    useGetAllServiceProviderDetailMutation,
    useFindServiceProviderDetailByIdMutation,
    useFindServiceProviderDetailByUserIdMutation,
    useSaveServiceProviderDetailMutation,
    useUpdateServiceProviderDetailMutation,
    useDeleteServiceProviderDetailMutation,
    useServiceProviderIdMutation,
} = serviceProviderApi;